import Header from "@/components/Header";
import Hero from "@/components/Hero";
import AdMarquee from "@/components/AdMarquee";
import PlatformSection from "@/components/PlatformSection";
import VideoSection from "@/components/VideoSection";
import KnowledgeSection from "@/components/KnowledgeSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import BenefitsSection from "@/components/BenefitsSection";
import ConversionSection from "@/components/ConversionSection";
import GrowthSection from "@/components/GrowthSection";
import CTASection from "@/components/CTASection";
import EditorialSection from "@/components/EditorialSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { OrganizationSchema, FAQSchema } from "@/components/StructuredData";
import { seoMetadata } from "@/data/seo-metadata";

const faqs = [
  { question: "What is thinker and how does it work?", answer: "thinker is an AI-powered operations platform that helps e-commerce businesses automate tasks, streamline workflows, and grow faster with less chaos." },
  { question: "Who is thinker for?", answer: "thinker is built for e-commerce founders, operators, and small teams who are scaling and wearing too many hats." },
  { question: "Do I need to know how to code?", answer: "No. thinker is designed for non-technical users. Just plug in your store, and let the AI handle the rest." },
  { question: "What platforms does thinker integrate with?", answer: "thinker currently integrates with Shopify, Meta Ads, Google Analytics, and more with additional integrations launching soon." },
  { question: "Can thinker make decisions for me?", answer: "Yes. thinker uses AI agents to give you actionable recommendations and even auto-execute tasks you approve." },
  { question: "How do I get started?", answer: "Sign up, connect your Shopify store, and choose what you want to automate. You'll get results in minutes." }
];

const Index = () => {
  const seo = seoMetadata.home;
  
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalPath}
      />
      <OrganizationSchema />
      <FAQSchema faqs={faqs} />
      <Header />
      <main>
        <Hero />
        <AdMarquee />
        <VideoSection />
        <PlatformSection />
        <KnowledgeSection />
        <TestimonialsSection />
        <BenefitsSection />
        <ConversionSection />
        <GrowthSection />
        <CTASection />
        <EditorialSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
